var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Upload',{attrs:{"action":"/api/upload/upload","on-success":_vm.upload,"on-remove":_vm.uploadRemove}},[_vm._t("main",[_c('Button',{attrs:{"icon":"ios-cloud-upload-outline","size":"small","disabled":_vm.count>0}},[_vm._v("选择文件（上传图片）")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7223dfb2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public/upload/UploadOne.vue
// module id = null
// module chunks = 